import React from 'react';
import { Box, Grid,Paper, Typography } from '@mui/material';
import { useTranslation } from "react-i18next";


const Cancel = () => {
    const { t } = useTranslation();
    return (
        <Grid container alignItems={"center"} justifyContent={"center"}>
            <Grid item xs={6}>
                <Paper>
                    <Box sx={{p:4}}>
                        <Typography textAlign={"center"}>
                            {t("paymentUnsuccessful")}
                        </Typography>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
    
}


export default Cancel;